"use strict";

var _ruler = require("./util/ruler.js");

function toggleMeasure() {
  new _ruler.PathMeasurement(map, function () {
    $(".ranging").find("img").attr("src", "./assets/ceju.png");
  }).start();
  console.log('PathMeasurement', 123);
}

$(".ranging").on("click", function () {
  if ($(this).find("img").attr("src") == "./assets/ceju.png") {
    $(this).find("img").attr("src", "./assets/ceju_on.png");
    toggleMeasure();
  } else {
    $(this).find("img").attr("src", "./assets/ceju.png");
    destory();
  }
});


//////////////////
// WEBPACK FOOTER
// ./js/ranging.js
// module id = 35
// module chunks = 0